export const PANCAKE_EXTENDED = 'https://tokens.pancakeswap.finance/pancakeswap-extended.json'
export const COINGECKO = 'https://tokens.pancakeswap.finance/coingecko.json'
export const PANCAKE_ETH_DEFAULT = 'https://tokens.pancakeswap.finance/pancakeswap-eth-default.json'
export const PANCAKE_ETH_MM = 'https://tokens.pancakeswap.finance/pancakeswap-eth-mm.json'
export const PANCAKE_BSC_MM = 'https://tokens.pancakeswap.finance/pancakeswap-bnb-mm.json'
export const COINGECKO_ETH = 'https://tokens.coingecko.com/uniswap/all.json'
export const CMC = 'https://tokens.pancakeswap.finance/cmc.json'
export const CADINU = 'https://api.cadinu.io/token-list/'

export const ETH_URLS = [PANCAKE_ETH_DEFAULT, PANCAKE_ETH_MM, COINGECKO_ETH]
/**
 * Site review 59 #6 (2026-10-08): the PancakeSwap extended list is gone from BSC. It fails our validator ("8PAY v2", "PROS (old)",
 * a 41-character name; at least since its v2.16.797 of 2026-09-30), so it never added a token, cost 219 KB on every cold load and
 * logged "Token list failed validation" on every page. The picker's search for an unknown token reads cmc and coingecko, which are
 * fetched when a search is typed (state/lists/lazy.ts), not on load. The listed set is pinned by state/lists/__tests__/listedSet.test.ts.
 */
// 2026-10-08 (Bez): the PancakeSwap BNB Chain MM list is no longer offered under Manage > Lists (it served PancakeSwap's own
// market-maker quotes, which CADINU does not use). Leaving DEFAULT_LIST_OF_LISTS also deletes it from stored list state on the
// next load (token-lists reducer, lastInitializedDefaultListOfLists). PANCAKE_BSC_MM stays exported for useIsMMQuotingPair, which
// then never finds an MM pair on BSC.
export const BSC_URLS = [CADINU, CMC, COINGECKO]

// List of official tokens list
export const OFFICIAL_LISTS = [CADINU, PANCAKE_ETH_DEFAULT]

export const UNSUPPORTED_LIST_URLS: string[] = []
export const WARNING_LIST_URLS: string[] = []

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [
  ...BSC_URLS,
  ...ETH_URLS,
  ...UNSUPPORTED_LIST_URLS, // need to load unsupported tokens as well
  ...WARNING_LIST_URLS,
]

// default lists to be 'active' aka searched across (the active lists are the only ones fetched on load)
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [CADINU, PANCAKE_ETH_DEFAULT, PANCAKE_ETH_MM]

/**
 * Tokens no list offers on a chain, whatever list is active (Bez, 2026-10-02: BUSD on BSC is wound down). They are dropped
 * when a list is turned into a token map and skipped in the inactive-list search. Import by address still works: a holder
 * pastes the address, the token is read from the chain, the import is confirmed and the swap out goes through as before.
 */
export const HIDDEN_LIST_TOKENS: Record<number, ReadonlySet<string>> = {
  56: new Set(['0xe9e7cea3dedca5984780bafc599bd69add087d56']),
}
export const isHiddenListToken = (chainId: number | undefined, address: string | undefined): boolean =>
  !!chainId && !!address && (HIDDEN_LIST_TOKENS[chainId]?.has(address.toLowerCase()) ?? false)
